import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { Form } from "ant-design-vue";
import {
    createFieldDatetime,
    createFieldInput, createFieldInputNumber,
    createFieldSelect
} from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import { createForm } from "./open-inspection-info.logic";

const CSelect = defineAsyncComponent(() => import("../../../../../../components/input/template-builder/select/CSelect"));

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });
export const callTransportByWay = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TRANSPORT_BY_WAY", value: searchQuery });
export const callQuantityUnit = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "QUANTITY_UNIT", value: searchQuery });

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    if (key && !lodash.get(modelRef, key)) {
        lodash.set(modelRef, key, createForm({ refRelease: modelRef.refReleaseTemp }));
    }
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}inspectionDatetime`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.openInspection.inspectionDatetime")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.inspectionDatetime,
                            "onUpdate:value": value => {
                                model.inspectionDatetime = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTransportByWay`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.openInspection.refTransportByWay")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refTransportByWay,
                            "onUpdate:value": value => {
                                model.refTransportByWay = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            list: callTransportByWay,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}vehicleNo`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.openInspection.vehicleNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.vehicleNo,
                            "onUpdate:value": value => {
                                model.vehicleNo = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}netWeight`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.openInspection.netWeight"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.netWeight,
                            "onUpdate:value": value => {
                                model.netWeight = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model?.refNetWeightUnit,
                                        "onUpdate:value": value => {
                                            model.refNetWeightUnit = value;
                                            model.isSave = true;
                                        },
                                        disabled: viewOnly,
                                        list: callQuantityUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refNetWeightUnit` }, model }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refNetWeightUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}qty`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.openInspection.qty"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.qty,
                            "onUpdate:value": value => {
                                model.qty = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model?.refQtyUnit,
                                        "onUpdate:value": value => {
                                            model.refQtyUnit = value;
                                            model.isSave = true;
                                        },
                                        disabled: viewOnly,
                                        list: callQuantityUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refQtyUnit` }, model }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refQtyUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}qtySampling`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.openInspection.qtySampling"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.qtySampling,
                            "onUpdate:value": value => {
                                model.qtySampling = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model?.refQtySamplingUnit,
                                        "onUpdate:value": value => {
                                            model.refQtySamplingUnit = value;
                                            model.isSave = true;
                                        },
                                        disabled: viewOnly,
                                        list: callQuantityUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refQtySamplingUnit` }, model }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refQtySamplingUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}boxNo`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.openInspection.boxNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.boxNo,
                            "onUpdate:value": value => {
                                model.boxNo = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sealNo`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.openInspection.sealNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.sealNo,
                            "onUpdate:value": value => {
                                model.sealNo = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};
